import { Product } from './types'

export const getPriceAmount = (product?: Product): Readonly<number> => {
  return parseFloat(product?.priceRange?.maxVariantPrice?.amount || '0')
}

export const getPriceCurrency = (product?: Product, fallback = currencyCodeFallback): Readonly<string> => {
  return product?.priceRange?.maxVariantPrice?.currencyCode || fallback
}

export const getDiscount = (product?: Product): Readonly<number> => {
  return (
    product?.variants?.reduce((maxDiscount, variant) => {
      const price = parseFloat(variant.price.amount)
      const compareAt = variant.compareAtPrice ? parseFloat(variant.compareAtPrice.amount) : 0
      const discountAmount = compareAt > price ? compareAt - price : 0

      return Math.max(maxDiscount, discountAmount)
    }, 0) || 0
  )
}

export const currencyCodeFallback: Readonly<string> = 'EUR'
